import { render, staticRenderFns } from "./ModalAgregarModelo.vue?vue&type=template&id=1b3185b2"
import script from "./ModalAgregarModelo.vue?vue&type=script&lang=js"
export * from "./ModalAgregarModelo.vue?vue&type=script&lang=js"
import style0 from "./ModalAgregarModelo.vue?vue&type=style&index=0&id=1b3185b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports